// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2O5PB","btnWrapper":"styles_btnWrapper__TJseJ"};